export default "__VITE_ASSET__4673de48__"